export default "__VITE_ASSET__BA8RBoO4__"